import Vue from 'vue';
// import 'ant-design-vue/dist/antd.css';

import {
    ConfigProvider,
    Layout,
    Col,
    Row,
    Space,
    Breadcrumb,
    Pagination,
    Button,
    Checkbox,
    Dropdown,
    Icon,
    Input,
    InputNumber,
    Menu,
    Radio,
    Rate,
    Select,
    Switch,
    TreeSelect,
    Upload,
    Badge,
    Card,
    Drawer,
    Form,
    FormModel,
    List,
    Popover,
    Progress,
    Skeleton,
    Table,
    Tabs,
    Tree,
    Tooltip,
    DatePicker,
    Modal,
    TimePicker,
    Spin,
    Divider,
    Popconfirm,
    Cascader
} from 'ant-design-vue';

Vue.use(ConfigProvider);

Vue.use(Layout);
Vue.use(Col);
Vue.use(Row);
Vue.use(Space);

Vue.use(Breadcrumb);
Vue.use(Pagination);

Vue.use(Button);
Vue.use(Checkbox);
Vue.use(Dropdown);
Vue.use(Icon);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Menu);
Vue.use(Radio);
Vue.use(Rate);
Vue.use(Select);
Vue.use(Switch);
Vue.use(TreeSelect);
Vue.use(Upload);

Vue.use(Badge);
Vue.use(Card);
Vue.use(Drawer);
Vue.use(Form);
Vue.use(FormModel);
Vue.use(List);
Vue.use(Popover);
Vue.use(Progress);
Vue.use(Skeleton);
Vue.use(Table);
Vue.use(Tabs);
Vue.use(Tree);
Vue.use(Tooltip);

Vue.use(DatePicker);
Vue.use(Modal);
Vue.use(TimePicker);
Vue.use(Spin);

Vue.use(Divider);
Vue.use(Popconfirm);
Vue.use(Cascader);
